/**
 * Shared animation/transition constants for cross-platform (web + native) use.
 * Used for Pressable hover states and CSS transitions on web.
 */

import type { ViewStyle } from 'react-native';

export const WEB_HOVER_TRANSITION =
  'transform 0.15s ease, opacity 0.15s ease, background-color 0.15s ease';

/** Web-only style for Pressable; use with Platform.select({ web: WEB_HOVER_TRANSITION_STYLE }). */
export const WEB_HOVER_TRANSITION_STYLE: ViewStyle & { transition?: string } = {
  transition: WEB_HOVER_TRANSITION,
};
